import { customElement } from 'solid-element';
import { noShadowDOM } from 'component-register';
import TextInput, {
  TextInputFeedback,
  TextInputSize,
  TextInputType,
} from './TextInput';

export function defineSolidModusTextInput(): void {
  customElement(
    'tc-modus-text-input',
    {
      value: '',
      placeholder: undefined,
      inputId: undefined,
      name: undefined,
      type: 'text',
      size: 'md',
      bordered: true,
      disabled: false,
      readOnly: false,
      required: false,
      autoFocus: false,
      autoComplete: undefined,
      includeClear: false,
      includeSearch: false,
      customClass: undefined,
      dataTheme: undefined,
      label: undefined,
      maxLength: undefined,
      minLength: undefined,
      inputTabIndex: undefined,
      ariaLabel: undefined,
      feedback: undefined,
      onInputChange: undefined,
      onInputBlur: undefined,
      onInputFocus: undefined,
      onClearClick: undefined,
      shadowDom: false,
    },
    (props, { element }) => {
      if (!props.shadowDom) noShadowDOM();
      function dispatchInputChange(value: string): void {
        const evt = new CustomEvent<{ value: string }>('input-change', {
          detail: { value },
          bubbles: true,
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function dispatchBlur(): void {
        const evt = new CustomEvent('input-blur', {
          bubbles: true,
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function dispatchFocus(): void {
        const evt = new CustomEvent('input-focus', {
          bubbles: true,
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function dispatchClearClick(): void {
        const evt = new CustomEvent('clear-click', {
          bubbles: true,
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      return (
        <TextInput
          value={props.value}
          placeholder={props.placeholder}
          inputId={props.inputId}
          name={props.name}
          type={props.type as TextInputType | undefined}
          size={props.size as TextInputSize | undefined}
          bordered={props.bordered}
          disabled={props.disabled}
          readOnly={props.readOnly}
          required={props.required}
          autoFocus={props.autoFocus}
          autoComplete={props.autoComplete}
          includeClear={props.includeClear}
          includeSearch={props.includeSearch}
          customClass={props.customClass}
          dataTheme={props.dataTheme}
          label={props.label}
          maxLength={props.maxLength}
          minLength={props.minLength}
          inputTabIndex={props.inputTabIndex}
          ariaLabel={props.ariaLabel}
          feedback={props.feedback as TextInputFeedback | undefined}
          onInputChange={dispatchInputChange}
          onInputBlur={dispatchBlur}
          onInputFocus={dispatchFocus}
          onClearClick={dispatchClearClick}
        />
      );
    }
  );
}
